<div class="plataformas-topo">
  <app-button-padrao
    backgroundColor="var(--primary)"
    color="white"
    label="Adicionar Plataforma"
    width="380px"
    (buttonClick)="adicionarPlataforma()">
  </app-button-padrao>
</div>

<input #inputLogo type="file" class="input-logo-oculto" accept="image/*" (change)="aoSelecionarLogo($event)" />

<div class="lista-plataformas">
  @if (carregando) {
    @for (item of skeletonItens; track item) {
      <div class="flex-direction-column gap-15 container-plataforma">
        <div class="plataforma-header">
          <div class="skeleton skeleton-texto skeleton-titulo"></div>
          <div class="skeleton skeleton-icone"></div>
        </div>
        <div class="skeleton skeleton-label"></div>
        <div class="skeleton skeleton-input"></div>
        <div class="skeleton skeleton-label"></div>
        <div class="skeleton skeleton-input"></div>
        <div class="skeleton skeleton-botao"></div>
      </div>
    }
  } @else {
    @if (plataformas.length === 0) {
      <div class="sem-plataformas">
        <span class="font-14 weight-600">Nenhuma plataforma cadastrada</span>
        <span class="font-12">Clique em "Adicionar Plataforma" para cadastrar a primeira.</span>
      </div>
    }

    @for (card of plataformas; track card.chave) {
      <div class="flex-direction-column gap-13 container-plataforma">
        <div class="plataforma-header">
          <div class="label-lateral">
            <span class="ellipse">{{ card.nome.trim() || 'Nova Plataforma' }}</span>
          </div>
          <div class="flex-direction-row gap-5">
            <img class="cursor-pointer logo-plataforma"
              [src]="card.urlImg || './assets/icones/anexo.svg'"
              [class.logo-plataforma--imagem]="card.urlImg"
              [alt]="card.urlImg ? 'Logo da plataforma' : 'Adicionar logo'"
              matTooltip="Alterar logo da plataforma"
              role="button" tabindex="0"
              (click)="abrirSeletorLogo(card)" (keydown.enter)="abrirSeletorLogo(card)">
            <img class="cursor-pointer icone-remover"
              src="./assets/icones/delete-forever.svg"
              alt="Inativar plataforma" matTooltip="Inativar plataforma"
              role="button" tabindex="0"
              (click)="inativar(card, $index)" (keydown.enter)="inativar(card, $index)">
          </div>
        </div>

        <app-form-field
          label="Nome da plataforma"
          heightFormField="35px"
          widthFormField="100%"
          placeholder="Digite"
          [value]="card.nome"
          (changeValue)="card.nome = $event">
        </app-form-field>

        <app-form-field
          label="URL de busca da base dinâmica"
          heightFormField="35px"
          widthFormField="100%"
          placeholder="Digite"
          [value]="card.urlBaseDinamica"
          (changeValue)="card.urlBaseDinamica = $event">
        </app-form-field>

        <app-form-field
          label="URL dos dados da base dinâmica"
          heightFormField="35px"
          widthFormField="100%"
          placeholder="Digite"
          [value]="card.urlDadosBaseDinamica"
          (changeValue)="card.urlDadosBaseDinamica = $event">
        </app-form-field>

        <app-form-field
          label="Token"
          heightFormField="35px"
          widthFormField="100%"
          placeholder="Digite"
          [isSenha]="true"
          [value]="card.token"
          (changeValue)="card.token = $event">
        </app-form-field>

        <app-button-padrao
          backgroundColor="var(--verde-padrao)"
          color="white"
          [label]="card.salvando ? 'Salvando...' : 'Salvar'"
          width="100%"
          [disabled]="card.salvando"
          (buttonClick)="salvar(card)">
        </app-button-padrao>
      </div>
    }
  }
</div>
